/* eslint-disable no-use-before-define */
import { FC, useMemo } from 'react';
import { useCurrentRefinements } from 'react-instantsearch-hooks-web';
import { useEtimTranslation } from '../use/etim-translation';
import { LocalizedFilterText } from './LocalizedFilterText';

type CurrentRefinementsProps = {
  excludeAttributes: string[];
};

type RefinementTextProps = {
  attribute: string;
  label: string;
};

const RefinementText: FC<RefinementTextProps> = ({ attribute, label }) => {
  const { name, unit, translateEtimValue } = useEtimTranslation(attribute);

  return (
    <>
      {name}
      {unit && <span style={{ textTransform: 'initial' }}> [{unit}]</span>}:{' '}
      <LocalizedFilterText value={label} attribute={attribute} translateEtimValue={translateEtimValue} />
    </>
  );
};

export const CurrentRefinements: FC<CurrentRefinementsProps> = ({ excludeAttributes }) => {
  const { items, refine } = useCurrentRefinements({ excludedAttributes: excludeAttributes });

  const normalizedItems = useMemo(
    () =>
      items
        .map((item) => {
          const refinements = item.refinements.map((refinement) => ({
            ...refinement,
            label: refinement.label, // rewrite item.label
            attribute: item.attribute, // not refinement.attribute
          }));

          return refinements;
        })
        .flat(),
    [items, excludeAttributes]
  );

  return (
    <div className="ais-CurrentRefinements-list">
      <span className="ais-CurrentRefinements-item">
        {normalizedItems.map((item) => (
          <span className="ais-CurrentRefinements-category" key={item.attribute + item.operator ?? '_'}>
            <span className="ais-CurrentRefinements-categoryLabel">
              <RefinementText attribute={item.attribute} label={item.label} />
            </span>
            <button
              className="ais-CurrentRefinements-delete"
              onClick={() => refine(item)}
              type="button"
              aria-label="delete"
            >
              ✕
            </button>
          </span>
        ))}
      </span>
    </div>
  );
};
